import React, { useState, useEffect } from 'react';
import { Classroom } from '../../types/index';

interface ClassroomModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (classroom: { name: string; capacity: number }) => void;
    classroom?: Classroom;
}

const ClassroomModal: React.FC<ClassroomModalProps> = ({ isOpen, onClose, onSave, classroom }) => {
    const [name, setName] = useState(classroom?.name || '');
    const [capacity, setCapacity] = useState<number>(classroom?.capacity ?? 1);

    useEffect(() => {
        if (classroom) {
            setName(classroom.name);
            setCapacity(classroom.capacity);
        } else {
            setName('');
            setCapacity(1);
        }
    }, [classroom]);

    const handleSave = () => {
        if (!name.trim()) return;
        onSave({ name: name.trim(), capacity });
        onClose();
    };

    if (!isOpen) return null;

    const title = classroom ? 'Editar sala' : 'Crear sala';

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
                <h2 className="text-xl font-bold mb-4">{title}</h2>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Nombre de la sala
                    </label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="mt-1 p-2 border border-gray-300 rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nombre de la sala"
                    />
                </div>

                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Aforo (número de plazas)
                    </label>
                    <input
                        type="number"
                        min={1}
                        value={capacity}
                        onChange={(e) => setCapacity(Math.max(1, parseInt(e.target.value) || 1))}
                        className="mt-1 p-2 border border-gray-300 rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={!name.trim()}
                        className="px-4 py-2 bg-brand-primary text-white rounded hover:brightness-90 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ClassroomModal;
